<template>
  <van-popup v-model="show" :close-on-click-overlay="false">
    <div class="commonDialogBox">
      <div class="title">温馨提示</div>
      <!--   内容，待定   -->
      <div class="content">
        <div>亲爱的用户，欢迎使用{{ name }}！</div>
        <div>
          为保护您的权益并遵守相关监管要求，请您在登录前认真阅读并充分理解我们的<span
            class="black"
            @click="navigateToAgreement"
            >《服务协议》</span
          >，尤其是涉及免除或限制责任的条款，确保您清楚自身权利和义务。
        </div>
        <div>点击“同意”即表示您已阅读并同意《服务协议》的全部内容。</div>
        <div>如不同意，将退出本应用。</div>
        <div>感谢您的理解与支持！</div>
      </div>
      <!--   点击同意   -->
      <div class="confirmBtn" @click="clickConfirm">同意</div>
      <!--   点击不同意   -->
      <div class="cancelBtn" @click="clickCancel">不同意并退出</div>
    </div>
  </van-popup>
</template>

<script>
export default {
  model: {
    prop: "show",
    event: "change",
  },
  props: {
    show: Boolean,
  },
  data: function () {
    return {
      name: "",
      agreement_h5: "",
    };
  },
  mounted: function () {
    let channelCode = window.localStorage.getItem("channelCode_AI");
    switch (channelCode) {
      case "dxlc":
        this.name = "亮仔";
        this.agreement_h5 = process.env.VUE_APP_AGREEMENT_H5_DXLC;
        return;
      case "cxnt":
        this.name = "小慧";
        this.agreement_h5 = process.env.VUE_APP_AGREEMENT_H5_CXNT;
        return;
      case "pinba":
        this.name = "拼吧";
        this.agreement_h5 = process.env.VUE_APP_AGREEMENT_H5_PINBA;
        return;
    }
  },
  methods: {
    // 点击同意，弹框消失即可
    clickConfirm: function () {
      this.$emit("change", false);
      window.localStorage.setItem("AI_Agreement", "1");
    },
    //点击不同意，退出页面，目前适用于亮啦应用交互，产品定义其他接入方的处理待接入时再修改逻辑
    clickCancel: function () {
      const channelApp = localStorage.getItem("channel_App") || "other";
      this.$emit("change", false);
      // 判断宿主 ...
      if (channelApp == "wechat") {
        // 微信小程序端退出
        wx.miniProgram.navigateBack({
          delta: 1,
        });
      } else if (channelApp == "app") {
        // app端退出
        DXLC_JSSDK("backNative", {}, async () => {
          result;
        });
      } else {
        //其他接入方，非亮啦，跳转提示页
        this.$router.replace({
          name: "TipsPage",
        });
      }
    },
    //跳转使用协议
    navigateToAgreement: function () {
      window.location.href = this.agreement_h5;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./commonDialog3.scss";
</style>
